var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "align-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3h22.5v1.5h-22.5v-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 7.125h15.375v1.5h-15.375v-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 11.25h22.5v1.5h-22.5v-1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.375h15.375v1.5h-15.375v-1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 19.5h22.5v1.5h-22.5v-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.15db213486259c88059f5fed91d0ff81.svg";
export { ForwardRef as ReactComponent };